import React, {useEffect, useRef, useContext, useState} from "react";
import {Button, Table, Form, Input, InputNumber, Switch} from "antd";
import {useModel} from "../../../models";
import StockSelectionModal from "./StockSelectionModal";


const EditableContext = React.createContext();

const EditableRow = ({index, ...props}) => {
    const [form] = Form.useForm();
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    );
};
const EditableCell = ({
                          title,
                          editable,
                          children,
                          dataIndex,
                          record,
                          handleSave,
                          ...restProps
                      }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef();
    const form = useContext(EditableContext);
    useEffect(() => {
        if (editing) {
            inputRef.current.focus();
        }
    }, [editing]);

    const toggleEdit = () => {
        setEditing(!editing);
        form.setFieldsValue({
            [dataIndex]: record[dataIndex],
        });
    };

    const save = async e => {
        try {
            const values = await form.validateFields();
            toggleEdit();
            handleSave({...record, ...values});
        } catch (errInfo) {
            console.log('Save failed:', errInfo);
        }
    };

    let childNode = children;
    if (editable) {
        childNode = editing ? (
            <Form.Item
                style={{
                    margin: 0,
                }}
                name={dataIndex}
                rules={[
                    {
                        required: true,
                        message: `${title} is required.`,
                    },
                ]}
            >
                {

                    (() => {
                            if (dataIndex === "saleNum") {
                                return <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "80px"}}
                                />
                            } else if (dataIndex === "unitPrice") {
                                return <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "80px"}}
                                />
                            } else if (dataIndex === "discount") {
                                return <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "80px"}}
                                    formatter={value => `${value}%`}
                                    parser={value => value.replace('%', '')}
                                />
                            } else if (dataIndex === "quantityGifts") {
                                return <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "80px"}}
                                />
                            } else if (dataIndex === "discountPrice") {
                                return <InputNumber
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "80px"}}
                                />
                            } else if (dataIndex === "isProtect") {
                                return <Switch
                                    ref={inputRef}
                                    checked={record[dataIndex]}
                                    onClick={save}
                                    size="small"
                                />

                            } else if (dataIndex === "detailsDesc") {
                                return <Input.TextArea
                                    ref={inputRef}
                                    onPressEnter={save}
                                    onBlur={save}
                                    style={{width: "120px"}}
                                />
                            }
                        }
                    )()
                }
            </Form.Item>
        ) : (
            <div
                className="editable-cell-value-wrap"
                style={{
                    paddingRight: 24,
                }}
                onClick={toggleEdit}
            >
                {children}
            </div>
        );
    }

    return <td {...restProps}>{childNode}</td>;
};
const columns = [
    {
        title: '',
        width: 40,
        render: (text, record, index) => `${index + 1}`,
    },
    {
        title: '商品编号',
        dataIndex: 'materialId',
        align: 'left',
    },
    {
        title: '商品名称',
        dataIndex: 'materialName',
    },
    {
        title: '图号',
        dataIndex: 'replaceNum',
    },
    {
        title: '销售数量*',
        dataIndex: 'saleNum',
        editable: true,
    },
    {
        title: '单价*',
        dataIndex: 'unitPrice',
        editable: true,
    },
    {
        title: '折扣*',
        dataIndex: 'discount',
        editable: true,
        render: text => text + "%",
    },
    {
        title: '赠品数量*',
        dataIndex: 'quantityGifts',
        editable: true,
    },
    {
        title: '单品优惠*',
        dataIndex: 'discountPrice',
        editable: true,
    },
    {
        title: '三包*',
        dataIndex: 'isProtect',
        render: (text) => text ? "是" : "否",
        editable: true,
    },
    {
        title: '总计',
        render: (text, record) => (record.isProtect ? 0 : record.unitPrice * record.saleNum * record.discount/100 - record.discountPrice).toFixed(2),
    },

    {
        title: '单位',
        dataIndex: 'materialUnit',
    },
    {
        title: '仓库',
        dataIndex: 'warehouseName',
    },
    {
        title: '货位',
        dataIndex: 'shelfName',
    },
    {
        title: '库存',
        dataIndex: 'inventoryQuantity',
    },
    {
        title: '备注',
        dataIndex: 'detailsDesc',
        editable: true,
    },
];
const components = {
    body: {
        row: EditableRow,
        cell: EditableCell,
    },
};

export default function () {
    const [
        {
            documentMaterialList, selectedDocumentMaterial,selectedDocumentMaterialRowKeys
        },
        {
            setDocumentMaterialList, setSelectedDocumentMaterial,
            setSelectedDocumentMaterialRowKeys, setAddMaterialModelVisible,
            removeDocumentMaterial
        }
    ] = useModel("purchaseOrder");



    const mapColumns = columns.map(col => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: record => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: row => {
                    // console.log(row);
                    setDocumentMaterialList(
                        documentMaterialList.map(el => {
                            if (el.key === row.key) {
                                return {...el, ...row}
                            } else {
                                return el;
                            }
                        })
                    )

                },
            }),
        };
    });

    const TableHeader = () => {
        const onAdd = () => {
            setAddMaterialModelVisible(true);
        }
        const onDelete = () => {
            if (!!selectedDocumentMaterial) {
                removeDocumentMaterial(selectedDocumentMaterial);
            }
        }
        const onExport = () => {
        }
        const onImport = () => {
        }
        const onDownloadTpl = () => {

        }
        return (
            <div style={{margin: "0 0 8px", display: "flex"}}>
                <div className="detail-list-statistic">
                    <span className="margin-left-8">总金额：25000.00</span>
                    <span className="margin-left-16">初始需求总量：25000</span>
                    <span className="margin-left-16">最终需求量：25000</span>
                </div>
                <div style={{width: "460px", textAlign: "right"}}>
                    <Button
                        type="primary"
                        onClick={onAdd}
                    >
                        新增商品
                    </Button>
                    <Button className="margin-left-8"
                            onClick={onDelete}
                            disabled={!!!selectedDocumentMaterial}
                    >
                        删除商品
                    </Button>
                    <Button className="margin-left-8" onClick={onExport}>导出明细</Button>
                    <Button className="margin-left-8" onClick={onImport}>导入</Button>
                    <Button className="margin-left-8" onClick={onDownloadTpl}>下载模板</Button>
                </div>
            </div>
        )
    }
    return (
        <>
            <TableHeader/>
            <Table
                components={components}
                columns={mapColumns}
                dataSource={documentMaterialList}
                bordered
                pagination={false}
                /*onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedDocumentMaterial && selectedDocumentMaterial.key === record.key) {
                                setSelectedDocumentMaterial(null);
                                setSelectedDocumentMaterialRowKeys([]);
                            } else {
                                setSelectedDocumentMaterial(record);
                                setSelectedDocumentMaterialRowKeys([record.key]);
                            }
                        },
                    };
                }}*/
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedDocumentMaterial(selectedRows[0])
                        setSelectedDocumentMaterialRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentMaterialRowKeys
                }}
                scroll={{x: 'max-content'}}
            />

            <StockSelectionModal/>
        </>
    )
}